// extracted by mini-css-extract-plugin
export default {"paginateRoot":"styles_paginateRoot__3icdV"};